import(/* webpackMode: "eager" */ "/app/services/posa-website/src/app/error.tsx");
